import React, { useState, useEffect } from 'react';
import { makeStyles, TextField, Button } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { FaWallet, FaExchangeAlt, FaDollarSign, FaBitcoin } from 'react-icons/fa';
import { IconButton, Tooltip } from '@material-ui/core';
import { metamaskLogo } from './config';
import { ethers } from 'ethers';
import { futLogoIcon200 } from './config';
import SwapPage from './SwapPage';

const useStyles = makeStyles((theme) => ({
    swapDialog: {
        color: 'lightgray',
    },
    swapText: {
        fontFamily: "'Roboto Mono', monospace",
        fontSize: '14px',
    },
    inputStyle: {
        width: '180px'
    },
    row: {
        margin: '0px',
        padding: '0px', 
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    linkButtonStyle: {
        color: 'white',
        backgroundColor: 'transparent',
        border: 'none',
        padding: '2px 4px', // Further reduce padding
        margin: '0',
        textDecoration: 'none',
        cursor: 'pointer',
        fontSize: '12px',
        textTransform: 'none',
        lineHeight: '1', // Reduce line height
    },
    walletButton: {
        borderRadius: '20px',  // Rounded corners
        borderColor: 'white',
        borderWidth: '2px',
        borderStyle: 'solid',
        backgroundColor: '#D3D3D3', // Light gray background
        color: theme.palette.primary.main, // Text color using primary from theme
        marginRight: '20px',
        height: '30px', // Smaller height
        '&:hover': {
            backgroundColor: '#B0B0B0' // Darker gray on hover
        }
    },
    toolIconStyle: {
        margin: theme.spacing(0.0), // No external margins
        padding: '5px', // Reduce padding inside the IconButton
        color: 'rgba(255, 255, 255, 0.7)', // Makes the color less bright
        '&:hover': {
            color: 'rgba(255, 255, 255, 1.0)', // Slightly brighter on hover
        },
        '& svg': { // Assuming the FontAwesome icon renders as an <svg> element
            fontSize: '0.9em',
        },
    },
    stack: {
        position: 'relative',
        display: 'inline-block',
        width: '1em',
        height: '1em',
      },
    bitcoin: {
        position: 'absolute',
        width: '1em',
        height: '1em',
        left: '0.1em', // Adjust this value to move the icon horizontally
        top: '0.0em', // Adjust this value to move the icon vertically
    },
    exchange: {
        position: 'absolute',
        width: '1em',
        height: '1em',
        left: '0.1em', // Adjust this value to move the icon horizontally
    },
    linkButtonStyle: {
        fontSize: '10px',
      },
}));

function WalletButton({ onClick, label }) {
    const classes = useStyles();
  
    return (
      <Button
        onClick={onClick}
        className={classes.walletButton}
      >
        {label}
      </Button>
    );
}

// Using our improved SwapPage component that delivers ultra-low fees (~$0.32)
// instead of the older SwapDialog implementation


const WalletConnect = ({ activeNodeId, activeNodeName, tokenPriceParam, tokenUniswapVersion, ethPrice, e3dPrice, setUserAddress }) => {
    const [walletAddress, setWalletAddress] = useState('');
    const [provider, setProvider] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogOpenE3D, setDialogOpenE3D] = useState(false);
    const classes = useStyles();

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleOpenDialogE3D = () => {
        setDialogOpenE3D(true);
    };

  const handleCloseDialogE3D = () => {
        setDialogOpenE3D(false);
    };

    const requestAccount = async () => {
        if (window.ethereum) {
            try {
                const accounts = await window.ethereum.request({
                    method: 'eth_requestAccounts'
                });
                setWalletAddress(accounts[0]);
                setUserAddress(accounts[0]);
                const provider1 = new ethers.providers.Web3Provider(window.ethereum);
                console.log(provider1);
                setProvider(provider1);
            } catch (error) {
                console.error("Failed to get wallet access", error);
            }
        } else {
            alert('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html');
        }
    }; 

    useEffect(() => {
        const checkIfWalletIsConnected = async () => {
            if (window.ethereum) {
                try {
                    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
                    if (accounts.length > 0) {
                        setWalletAddress(accounts[0]);
                        setUserAddress(accounts[0]);
                        const provider1 = new ethers.providers.Web3Provider(window.ethereum);
                        console.log(provider1);
                        setProvider(provider1);
                    }
                } catch (error) {
                    console.error("Failed to retrieve wallet", error);
                }
            }
        };

        checkIfWalletIsConnected();
    }, []);
    
    const disconnectWallet = () => {
        // Clear the wallet address state
        setWalletAddress(null);
        setUserAddress(null);
        
        // Clear the provider state if you store it
        setProvider(null);
      
        // Note: Modern MetaMask versions don't allow direct modification of selectedAddress
        // We can only clear our application state, not the wallet's internal state
        
        // Clear any other state or side effects as needed
        console.log("Wallet disconnected. Application state cleared.");
      
        // If you need to do any further clean-up, do it here
    };
 
    return (
        <div>
            {walletAddress ? (
                <div style={{display: 'flex', paddingRight: '10px'}}>

                    {tokenPriceParam && (
                        <div style={{display: 'flex', paddingRight: '10px'}}>
                            <Tooltip title="Swap ETH for current Token">
                                <IconButton enabled={tokenPriceParam} onClick={handleOpenDialog} className={classes.toolIconStyle}>
                                    <span className={classes.stack}>
                                        <FaBitcoin className={classes.bitcoin} style={{width:'25px', height:'25px', color: 'green'}}/>
                                        <FaExchangeAlt className={classes.exchange} />
                                    </span>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Swap ETH for E3D Token">
                                <IconButton enabled={tokenPriceParam} onClick={handleOpenDialogE3D} className={classes.toolIconStyle}>
                                    <span className={classes.stack}>
                                        <img src={futLogoIcon200} style={{width:'25px', height:'25px', color: 'white'}} alt="" className={classes.bitcoin}/>
                                        <FaExchangeAlt className={classes.exchange} />
                                    </span>
                                </IconButton>
                            </Tooltip>
                        </div>
                    )}

                    <div style={{border: '1px solid green' }} >
                        <Tooltip title="Disconnect Wallet">
                            <IconButton onClick={disconnectWallet} className={classes.toolIconStyle}>
                                <img src={metamaskLogo} style={{width:'30px', height:'30px'}} alt="Connect Wallet"/> 
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            ) : (
                <div>
                    <Tooltip title="Connect Wallet">
                        <IconButton onClick={requestAccount} className={classes.toolIconStyle}>
                            <img src={metamaskLogo} style={{width:'30px', height:'30px'}} alt="Connect Wallet"  /> 
                        </IconButton>
                    </Tooltip>
                </div>
            )}
            <SwapPage
                open={dialogOpen}
                onClose={handleCloseDialog}
                tokenName={activeNodeName}
                tokenAddress={activeNodeId}
                provider={provider}
                walletAddress={walletAddress}
                tokenUniswapVersion={tokenUniswapVersion}
                tokenPriceParam={tokenPriceParam}
                ethPrice={ethPrice}
                isDialog={true}
                isCurrentToken={true} // Flag to indicate this is the current token swap
            />
            <SwapPage
                open={dialogOpenE3D}
                onClose={handleCloseDialogE3D}
                tokenName={"E3DToken"}
                tokenAddress={"0x6488861b401F427D13B6619C77C297366bCf6386"}
                provider={provider}
                walletAddress={walletAddress}
                tokenPriceParam={e3dPrice}
                tokenUniswapVersion={tokenUniswapVersion}
                ethPrice={ethPrice}
                isDialog={true}
            />
        </div>
    );
};

export default WalletConnect;
